import { render } from "./CustomTopicModelEditorOptions.vue?vue&type=template&id=51d47396"
import script from "./CustomTopicModelEditorOptions.vue?vue&type=script&lang=js"
export * from "./CustomTopicModelEditorOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__